module.exports = __webpack_public_path__ + "static/img/20b.f606dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20b.jpg
// module id = KbTF
// module chunks = 0